import React from 'react'

export const ImageIcon = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
    >
      <path
        d="M17 0H3C2.20435 0 1.44129 0.316071 0.87868 0.87868C0.316071 1.44129 0 2.20435 0 3V13C0 13.7956 0.316071 14.5587 0.87868 15.1213C1.44129 15.6839 2.20435 16 3 16H17C17.7956 16 18.5587 15.6839 19.1213 15.1213C19.6839 14.5587 20 13.7956 20 13V3C20 2.20435 19.6839 1.44129 19.1213 0.87868C18.5587 0.316071 17.7956 0 17 0ZM3 14C2.73478 14 2.48043 13.8946 2.29289 13.7071C2.10536 13.5196 2 13.2652 2 13V10.58L5.3 7.29C5.48693 7.10677 5.73825 7.00414 6 7.00414C6.26175 7.00414 6.51307 7.10677 6.7 7.29L13.41 14H3ZM18 13C18 13.2652 17.8946 13.5196 17.7071 13.7071C17.5196 13.8946 17.2652 14 17 14H16.23L12.42 10.17L13.3 9.29C13.4869 9.10677 13.7382 9.00414 14 9.00414C14.2618 9.00414 14.5131 9.10677 14.7 9.29L18 12.58V13ZM18 9.76L16.12 7.89C15.5501 7.34243 14.7904 7.03663 14 7.03663C13.2096 7.03663 12.4499 7.34243 11.88 7.89L11 8.77L8.12 5.89C7.55006 5.34243 6.79036 5.03663 6 5.03663C5.20964 5.03663 4.44994 5.34243 3.88 5.89L2 7.76V3C2 2.73478 2.10536 2.48043 2.29289 2.29289C2.48043 2.10536 2.73478 2 3 2H17C17.2652 2 17.5196 2.10536 17.7071 2.29289C17.8946 2.48043 18 2.73478 18 3V9.76Z"
        fill="#7E92A2"
      />
    </svg>
  )
}
